module.exports = "img/chevron-left.82128ee.png";